import type { SmishingRequestCategory } from "./smishing-chat-api";

function getLanguageBase(language?: string): string {
  return (language || "en").split("-")[0].toLowerCase();
}

export function getSmishingInputSuggestions(
  category: SmishingRequestCategory | undefined,
  language?: string
): string[] {
  if (!category) {
    return [];
  }

  const lang = getLanguageBase(language);

  switch (category) {
    case "referenceNumber":
      return ["TRK-48291", "PKG-1934", "REF-77421"];
    case "verificationCode":
      return ["482913", "731204", "948215"];
    case "employeeId":
      return ["EMP-4821", "STAFF-1934", "ID-7721"];
    case "username":
      return lang === "tr"
        ? ["ayse.yilmaz", "mehmet.demir", "operasyon24"]
        : ["alex.morgan", "sarah.lee", "opsdesk24"];
    case "email":
      return lang === "tr"
        ? ["ayse.yilmaz@example.com", "mehmet.demir@example.com", "destek@example.com"]
        : ["alex.morgan@example.com", "sarah.lee@example.com", "support@example.com"];
    case "phone":
      return lang === "tr"
        ? ["0555 234 5678", "0532 445 1188", "0541 882 3104"]
        : lang === "ar"
          ? ["050 123 4567", "055 234 9876", "056 778 2211"]
        : ["07700 900123", "07700 900456", "07700 900789"];
    case "fullName":
      return lang === "tr"
        ? ["Ayse Yilmaz", "Mehmet Demir", "Elif Kaya"]
        : lang === "ar"
          ? ["أحمد علي", "سارة خالد", "ليلى حسن"]
        : ["Alex Morgan", "Sarah Lee", "Daniel Foster"];
    case "department":
      return lang === "tr"
        ? ["Lojistik", "Insan Kaynaklari", "Operasyon"]
        : lang === "ar"
          ? ["الخدمات اللوجستية", "الموارد البشرية", "العمليات"]
        : ["Logistics", "HR", "Operations"];
    case "address":
      return lang === "tr"
        ? ["Cami Mah. Gul Sokak No: 43", "Ataturk Cad. No: 12 D:4"]
        : lang === "ar"
          ? ["شارع النور 12، دبي", "مبنى 8، شارع الخليج، الرياض"]
        : ["24 Oak Street", "18 River Road Apt 4"];
    case "password":
    default:
      return [];
  }
}
